import { getToken } from 'firebase/messaging';
import { getErrorReporter } from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';

import { getPushNotificationToken, initPushNotifications } from './helpers';

export const fetchFreshPushToken = async () => {
  const serviceWorkerRegistration = await window.navigator.serviceWorker?.ready;

  const messaging = initPushNotifications();

  return (
    (await window.electron?.getFcmToken?.()) ??
    (await getToken(messaging, {
      serviceWorkerRegistration,
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
    }))
  );
};

export const getPushToken = async (uid: ID) => {
  if (!uid) {
    return;
  }

  try {
    return getPushNotificationToken(uid) ?? (await fetchFreshPushToken());
  } catch (error) {
    getErrorReporter().captureException(error, {
      tags: { source: 'get-push-token' },
    });
  }
};
